import { authDomain, authStore } from '@auth';
import { useMutation } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { useSetRecoilState } from 'recoil';

export const useSendCode = () => {
  const setCodeSentAt = useSetRecoilState(authStore.codeSentAtSelector);

  return useMutation(
    (payload: authDomain.SendCodeDto) => {
      return authDomain.authService.sendCode(payload);
    },
    {
      onSuccess: () => {
        setCodeSentAt(dayjs().toISOString());
      },
    },
  );
};
